export default "__VITE_ASSET__Cyc5SwxX__"